import React, { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export default function FamilyField({
  value,
  onChange,
  llm_configs,
  disabled = false,
  error = false,
}) {
  const families = useMemo(() => Object.keys(llm_configs || {}), [llm_configs]);

  return (
    <FormControl fullWidth disabled={disabled} error={error}>
      <InputLabel id='endpoint-llm-family-label'>Model Family</InputLabel>
      <Select
        labelId='endpoint-llm-family-label'
        label='Model Family'
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
      >
        {families.map((family) => (
          <MenuItem key={family} value={family}>
            {llm_configs?.[family]?.label || family}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

